<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-heart-outline";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 42 37">
			<path
				d="M20.8333 36.8229C20.3472 36.8229 19.8528 36.7361 19.35 36.5625C18.8472 36.3889 18.4042 36.1111 18.0208 35.7292L14.4271 32.4479C10.7465 29.0799 7.42153 25.7382 4.45208 22.4229C1.48264 19.1076 -0.00138792 15.4528 9.73975e-07 11.4583C9.73975e-07 8.19444 1.09375 5.46875 3.28125 3.28125C5.46875 1.09375 8.19445 0 11.4583 0C13.2986 0 15.0347 0.390277 16.6667 1.17083C18.2986 1.95139 19.6875 3.01944 20.8333 4.375C21.9792 3.02083 23.3681 1.95347 25 1.17292C26.6319 0.392361 28.3681 0.00138889 30.2083 0C33.4722 0 36.1979 1.09375 38.3854 3.28125C40.5729 5.46875 41.6667 8.19444 41.6667 11.4583C41.6667 15.4514 40.191 19.1146 37.2396 22.4479C34.2882 25.7812 30.9375 29.1319 27.1875 32.5L23.6458 35.7292C23.2639 36.1111 22.8215 36.3889 22.3188 36.5625C21.816 36.7361 21.3208 36.8229 20.8333 36.8229ZM18.8542 8.54167C17.8472 7.11806 16.7708 6.03264 15.625 5.28542C14.4792 4.53819 13.0903 4.16528 11.4583 4.16667C9.375 4.16667 7.63889 4.86111 6.25 6.25C4.86111 7.63889 4.16667 9.375 4.16667 11.4583C4.16667 13.2639 4.80903 15.1826 6.09375 17.2146C7.37847 19.2465 8.91528 21.2167 10.7042 23.125C12.4931 25.0333 14.3333 26.8215 16.225 28.4896C18.1167 30.1576 19.6528 31.5292 20.8333 32.6042C22.0139 31.5278 23.5507 30.1563 25.4438 28.4896C27.3368 26.8229 29.1771 25.0347 30.9646 23.125C32.7521 21.2153 34.2882 19.2451 35.5729 17.2146C36.8576 15.184 37.5 13.2653 37.5 11.4583C37.5 9.375 36.8056 7.63889 35.4167 6.25C34.0278 4.86111 32.2917 4.16667 30.2083 4.16667C28.5764 4.16667 27.1875 4.54028 26.0417 5.2875C24.8958 6.03472 23.8194 7.11944 22.8125 8.54167C22.5694 8.88889 22.2743 9.14931 21.9271 9.32292C21.5799 9.49653 21.2153 9.58333 20.8333 9.58333C20.4514 9.58333 20.0868 9.49653 19.7396 9.32292C19.3924 9.14931 19.0972 8.88889 18.8542 8.54167Z"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 42 37"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
	fill="currentColor"
>
	<use href="#{symbolId}" />
</svg>
